import { siteMeta } from '@/mocks/cinema';

const heroStats = [
  { label: '今日实时票房', value: '1.21', unit: '亿元', sub: '较昨日 +8.4%', delta: 'up' },
  { label: '在映影片', value: '18', unit: '部', sub: '今日新增 3 部', delta: 'up' },
  { label: '累计观影人次', value: '326', unit: '万人次', sub: '同比上周五 +5.2%', delta: 'up' },
  { label: '场次供给', value: '16.8', unit: '万场', sub: '排片总场次', delta: 'flat' },
];

export default function Hero() {
  return (
    <section id="top" className="relative isolate overflow-hidden bg-foreground-950">
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage:
            "url('https://readdy.ai/api/search-image?query=wide%20cinematic%20panorama%20of%20a%20grand%20movie%20theater%20interior%20with%20rows%20of%20crimson%20red%20velvet%20seats%2C%20single%20brilliant%20projector%20beam%20of%20warm%20amber%20light%20cutting%20through%20soft%20fog%2C%20dramatic%20dark%20atmosphere%2C%20deep%20red%20and%20gold%20color%20palette%2C%20cinematic%20production%20design%2C%20moody%20dramatic%20lighting&width=1800&height=1100&seq=hero-cinema-01&orientation=landscape')",
        }}
      ></div>
      <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/80 via-foreground-950/60 to-background-50"></div>

      <div className="relative mx-auto w-full max-w-7xl px-4 pb-16 pt-28 md:px-6 md:pb-20 md:pt-36">
        <div className="mx-auto w-full max-w-3xl text-center">
          <span className="inline-flex items-center gap-2 rounded-full bg-background-50/10 px-4 py-1.5 text-xs font-medium text-accent-300 ring-1 ring-inset ring-background-50/20 backdrop-blur">
            <i className="ri-radio-2-line text-sm"></i>
            票房 · 排片 · 上映 · 档期 一站尽览
          </span>
          <h1 className="mt-6 text-3xl font-bold leading-tight text-background-50 md:text-5xl md:leading-tight">
            吃瓜影院
            <span className="mx-2 inline-block text-accent-400">·</span>
            今天的场子有多热，看完再决定
          </h1>
          <p className="mx-auto mt-5 max-w-2xl text-sm leading-relaxed text-background-100/85 md:text-base">
            首页直接更新吃瓜影院票房数字、排片分布与上映名单。新片什么时候放、哪些影片票房冲得快，点开相关条目就能看到当前排行与场次热度。
          </p>

          <div className="mt-8 flex flex-col items-center justify-center gap-3 sm:flex-row">
            <a
              href="#boxoffice"
              onClick={(e) => {
                e.preventDefault();
                document.getElementById('boxoffice')?.scrollIntoView({ behavior: 'smooth' });
              }}
              className="inline-flex w-full items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-600 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-500 sm:w-auto"
            >
              看实时票房榜
              <i className="ri-trophy-line text-base"></i>
            </a>
            <a
              href="#schedule"
              onClick={(e) => {
                e.preventDefault();
                document.getElementById('schedule')?.scrollIntoView({ behavior: 'smooth' });
              }}
              className="inline-flex w-full items-center justify-center gap-2 whitespace-nowrap rounded-md bg-background-50/10 px-6 py-3 text-sm font-medium text-background-50 ring-1 ring-inset ring-background-50/25 backdrop-blur transition-colors hover:bg-background-50/20 sm:w-auto"
            >
              查今日排片场次
              <i className="ri-calendar-check-line text-base"></i>
            </a>
          </div>
        </div>

        <div className="mt-12 grid grid-cols-2 gap-3 md:mt-16 md:grid-cols-4 md:gap-4">
          {heroStats.map((s) => (
            <div
              key={s.label}
              className="rounded-lg border border-background-50/10 bg-foreground-900/40 px-4 py-4 backdrop-blur md:px-5 md:py-5"
            >
              <p className="text-xs text-background-100/70">{s.label}</p>
              <div className="mt-2 flex items-end gap-1">
                <span className="font-display text-2xl font-bold text-accent-400 md:text-3xl">{s.value}</span>
                <span className="mb-1 text-xs text-background-100/70">{s.unit}</span>
              </div>
              <p
                className={`mt-1.5 flex items-center gap-1 text-xs ${
                  s.delta === 'up' ? 'text-primary-300' : 'text-background-100/70'
                }`}
              >
                <i className={`${s.delta === 'up' ? 'ri-arrow-up-line' : 'ri-equal-line'}`}></i>
                {s.sub}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}